import {useSelector} from 'react-redux';
import cx from 'classnames';
import {Box} from '~/CreateFabricInvitation/components/Box/Box';
import {EditorGroup} from '~/CreateFabricInvitation/components/EditorGroup/EditorGroup';
import {EditorHeader} from '~/CreateFabricInvitation/components/EditorHeader/EditorHeader';
import {TextColorPicker} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/ColorPicker/TextColorPicker';
import {ResetStyle} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/ResetStyle/ResetStyle';
import {TextFormat} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/TextFormat/TextFormat';
import {LetterSpacing} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/LetterSpacing/LetterSpacing';
import {LineHeight} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/LineHeight/LineHeight';
import {TextSize} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/TextSize/TextSize';
import {Dropdown} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/Dropdown/Dropdown';
import {EditBox} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/EditBox/EditBox';
import {selectEditorDisabled} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';
import {TextEditor} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/Desktop/TextEditor/TextEditor';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {menuMappingKeys} from '~/CreateFabricInvitation/routes/EventCreateDesign/constants';
import {largishAndUp} from '~libSass/base/_exports.sass';

import './CardEditorDesktop.sass';

export const CardEditorDesktop = () => {
  const editorDisabled = useSelector(selectEditorDisabled);
  const {matches: isDesktop} = useMatchQuery(`(min-width: ${largishAndUp})`);
  const isMobile = !isDesktop;

  if (isMobile) {
    return null;
  }

  return (
    <div
      className={cx({
        card_editor: true,
        'card_editor--disabled': editorDisabled,
      })}
    >
      <EditBox className="card_editor__content">
        <TextEditor />
        <EditorGroup>
          <EditorHeader
            title="Text Style"
            extra={
              <ResetStyle
                label="Reset"
                style={menuMappingKeys.FONT_STYLE}
                dataQaId="step1-textstyle-reset"
              />
            }
          />
          <Dropdown />
        </EditorGroup>
        <EditorGroup>
          <EditorHeader
            title="Text Size"
            extra={
              <ResetStyle
                label="Reset"
                style={menuMappingKeys.FONT_SIZE}
                dataQaId="step1-textsize-reset"
              />
            }
          />
          <TextSize />
        </EditorGroup>
        <EditorGroup>
          <EditorHeader
            title="Text Color"
            extra={
              <ResetStyle
                label="Reset"
                style={menuMappingKeys.COLOR}
                dataQaId="step1-textcolor-reset"
              />
            }
          />
          <Box height="10rem">
            <TextColorPicker showAll />
          </Box>
        </EditorGroup>
        <EditorGroup>
          <EditorHeader
            title="Text Format"
            extra={
              <ResetStyle
                label="Reset"
                style={menuMappingKeys.TEXT_FORMAT}
                dataQaId="step1-textformat-reset"
              />
            }
          />
          <Box>
            <TextFormat />
          </Box>
        </EditorGroup>
        <EditorGroup>
          <EditorHeader
            title="Spacing"
            extra={
              <ResetStyle
                label="Reset"
                style={menuMappingKeys.SPACING}
                dataQaId="step1-textspacing-reset"
              />
            }
          />
          <Box>
            <EditorHeader title="Letter Spacing" dark />
            <LetterSpacing />

            <EditorHeader title="Line Height" dark />
            <LineHeight />
          </Box>
        </EditorGroup>
      </EditBox>
    </div>
  );
};
